import axios from 'axios';
import { logger } from '@fiverr-private/obs';

export const getUserTeamData = (userId) =>
    axios
        .get(`/api/business-member/${userId}`)
        .then((res) => res.data)
        .catch((error) => {
            logger.error(error);
            throw error;
        });
